/* Core & libraries */
import React, { useEffect, useState } from "react";

/* Helpers, constants, custom methods, internal libraries */
import { useAirlineProgramsService } from "../../services/airlineProgramsService.js";
import { PAGE_TITLES } from "../../constants/appConstants.js";
import { useAnalytics } from "../../hooks/useAnalytics.js";

/* Components */
import ASProgramHeader from "../../components/asProgramHeader/index.js";
import ASProgramContent from "../../components/asProgramContent/index.js";
/* Styles */

const ProgramAS = () => {
    const { getAirlineProgramsData, delinkAlaskaAirlines, airlineProgramsData, joinAlaskaAirlines } = useAirlineProgramsService();
    const { initAnalytics } = useAnalytics();
    const [alaskaAirlinesSupplier, setAlaskaAirlinesSupplier] = useState({});

    useEffect(() => {
        (async () => {
            await getAirlineProgramsData()
        })();
        const initUtagData = {
            channel: 'content',
            pageName: PAGE_TITLES["alaskaAirlines"]
        };
        initAnalytics(initUtagData, 'init call', 'view')
    }, []);

    useEffect(() => {
        setAlaskaAirlinesSupplier(airlineProgramsData?.suppliers?.filter(
            supplier => supplier.providerName === "Alaska Airlines"
        )[0])
    }, [airlineProgramsData]);

    return (
        <div className="program-page">
            <ASProgramHeader airlineProgramsData={airlineProgramsData}/>
            <ASProgramContent
                delinkAlaskaAirlines={delinkAlaskaAirlines} 
                alaskaAirlinesSupplier={alaskaAirlinesSupplier} 
                joinAlaskaAirlines={joinAlaskaAirlines}
            />
        </div>
    )
}

export default ProgramAS;